module.exports = "https://www.niulinkcloud.com/_next/static/media/icon3.0656122bb50986adb4d8dce8d388a66e.png";